<template>
    <v-data-table
            :items="users"
            :headers="headers"
            item-key="id"
            :loading="loading"
            @click:row="showUser"
            :search="search"
            :custom-filter="customSearch">
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Benutzer Suchen"
                        single-line
                        hide-details
                        solo
                ></v-text-field>

                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="dialog = true">Neuer Benutzer</v-btn>
                <UserModal v-model="editedUser" :open="dialog" :title="dialogTitle" v-on:close="() => dialog = false" v-on:save="save"></UserModal>
            </v-toolbar>
        </template>
      <template v-slot:item.organisationalUnit="{ item }">

        <template v-if="item.organisationalUnit != null">{{item.organisationalUnit.name}}</template>
      </template>
        <template v-slot:item.enabled="{ item }">
            <v-simple-checkbox v-model="item.enabled" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.emailVerified="{ item }">
            <v-simple-checkbox v-model="item.emailVerified" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.role="{ item }">
            <v-chip>{{item.role.name}}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                    class="mr-2"
                    @click.stop="editUser(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                    color="red"
                    @click.stop="deleteUser(item)"
            >
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import {accountService} from "../services/accountService";
    import UserModal from "./UserModal";

    export default {
        name: "UserTable",
        props: ["query"],
        components: {UserModal},
        data: () => {
            return {
                search: "",
                loading: true,
                dialog: false,
                headers: [
                    {
                        text: "Vorname",
                        value: "firstname"
                    },
                    {
                        text: "Nachname",
                        value: "lastname"
                    },
                    {
                        text: "Email Adresse",
                        value: "email"
                    },
                  {
                    text: "Organisationseinheit",
                    value: "organisationalUnit"
                  },
                    {
                        text: "Email Adresse verifiziert",
                        value: "emailVerified",
                        align: "center"
                    },
                    {
                        text: "Aktiviert",
                        value: "enabled",
                        align: "center"
                    },
                    {
                        text: "Rolle",
                        value: "role",
                        align: "center"
                    },
                    {text: 'Aktionen', value: 'actions', sortable: false},
                ],
                users: [],
                editedIndex: -1,
                editedUser: {
                    id: 0,
                    email: "",
                    emailHash: "",
                    password: "",
                    firstname: "",
                    lastname: "",
                    enabled: false,
                  organisationalUnitId: null,
                  organisationalUnit: null,
                    visorId: null,
                    visor: null,
                    emailVerified: false,
                    roleId: 0,
                    role: null,
                    services: null,
                },
                defaultUser: {
                    id: 0,
                    email: "",
                    emailHash: "",
                    password: "",
                    firstname: "",
                    lastname: "",
                    enabled: false,
                  organisationalUnitId: null,
                  organisationalUnit: null,
                    visorId: null,
                    visor: null,
                    emailVerified: false,
                    roleId: 0,
                    role: null,
                    services: null,
                },
            };
        },
        computed: {
            dialogTitle () {
                return this.editedIndex === -1 ? "Neuer Benutzer" : "Benutzer bearbeiten"
            },
        },
        methods: {
          customSearch (value, search, item) {
            search = search.toLowerCase();
            return item && ((item.firstname.toLowerCase() + " " + item.lastname.toLowerCase()).includes(search) ||
                item.email.toLowerCase().includes(search) ||
                (item.organisationalUnit && item.organisationalUnit.name.toLowerCase().includes(search)) ||
                (item.role && item.role.name.toLowerCase().includes(search))
            );
          },
            showUser(user) {
                this.$router.push("/users/"+user.id);
            },
            save() {
                this.editedUser.visor = null;
                this.editedUser.organisationalUnit = null;
                this.editedUser.role = null;
                this.editedUser.services = null;
                if (this.editedIndex > -1) {
                    let self = this;
                    accountService.updateAccount(self.editedUser).then(function () {
                        self.fetchUsers()
                    }).then(function (error) {
                        console.log(error)
                    });
                } else {
                    let self = this;
                    accountService.createAccount(self.editedUser).then(function () {
                        self.fetchUsers()
                    }).then(function (error) {
                        console.log(error)
                    });
                }
                setTimeout(() => {
                    this.editedUser = Object.assign({}, this.defaultUser)
                    this.editedIndex = -1
                }, 300)
            },
            editUser(user) {
                this.editedIndex = this.users.indexOf(user)
                this.editedUser = Object.assign({}, user)
                this.dialog = true;
            },
            deleteUser(account) {
                if(!confirm("Willst du das Konto von " + account.firstname + " " + account.lastname + " wirklich löschen?"))
                    return;
                let self = this;
                accountService.deleteAccount(account.id).then(function () {
                    self.fetchUsers()
                }).then(function (error) {
                    console.log(error)
                });
                return account
            },
            fetchUsers() {
                let self = this;
                accountService.getQuery(this.query).then(response => {
                    self.users = response;
                    self.loading = false;
                }).catch((error) => {
                  console.log(error);
                  accountService.refreshToken().then(() => this.fetchUsers()).catch(() => accountService.signOut())
                })
            }
        },
        created() {
            this.fetchUsers();
        }
    }
</script>

<style scoped>

</style>